import type { TFunction } from 'i18next';
import type { ScheduledChangeSummary } from '@/common/api/models';
import { OralQuestionUpdateReview } from './OralQuestionUpdateReview';
import { WorkingModeSwitchReview } from './WorkingModeSwitchReview';

export const scheduledChangeViews = {
  oral_exam_question_update: {
    summary: (change: ScheduledChangeSummary, t: TFunction) => t(
      'lecturer.scheduledChanges.oralQuestions.summary',
      { count: change.questionCount ?? 0 },
    ),
    Review: OralQuestionUpdateReview,
  },
  working_mode_switch: {
    summary: (_change: ScheduledChangeSummary, t: TFunction) => t(
      'lecturer.scheduledChanges.workingMode.summary',
    ),
    Review: WorkingModeSwitchReview,
  },
} as const;
